import angular from 'angular';
import blogDetailComponent from './blog-detail.component';
import BlogDetailService from './blog-detail.service';
import blogDetailConfig from './blog-detail.config';

let blogDetailModule = angular.module('app.blogDetail',[])
  .component('blogDetail', blogDetailComponent)
  .service('BlogDetailService', BlogDetailService)
  .config(blogDetailConfig);

export default blogDetailModule;



// WEBPACK FOOTER //
// ./www/components/blog/blog-detail/blog-detail.js